import React from "react";
import { FormattedMessage } from "react-intl";

import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { TVehicle } from "types";

import TabbedOptions, { StackedOptions } from "./Tabs";

interface IOptions {
  vehicle: TVehicle;
  paperProps?: any;
  variant?: string;
}

const Options: React.FC<IOptions> = ({
  paperProps = {},
  vehicle,
}): JSX.Element => {
  return (
    <Paper variant="outlined" {...paperProps}>
      <Typography variant="h5" component="h2">
        <FormattedMessage
          id="pages.detail.ausstattung.label"
          defaultMessage="Ausstattung"
        />
      </Typography>

      {vehicle.ausstattung.length > 10 ? (
        <TabbedOptions vehicle={vehicle} />
      ) : (
        <StackedOptions vehicle={vehicle} />
      )}
    </Paper>
  );
};

export default Options;
